import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import deepmerge from 'deepmerge';

import SelectField, { SelectFieldMultiple } from '../../../../../common/select_field';
import { getAllPopsState } from '../../../../../../features/pop/get_all_pops';
import { getReservationStatusOptions } from '../../../../../common/utils/reservation_utils';
import { ReservationStatusEnum } from '../../../../../../core/enums/reservation/reservation';

const Filters = ({ queryParams, setQueryParams }) => {
    const [pop, setPop] = useState(queryParams?.queryFilter || 'none');
    const [reservationStatuses, setReservationStatuses] = useState([ReservationStatusEnum.FINISHED.value]);

    const getAllPops = useSelector(getAllPopsState);

    const onSelectPopChange = (event) => {
        setPop(event.target.value);

        if (event.target.value === 'none') {
            setQueryParams(prevState => deepmerge(prevState, { popId: '' }));
        } else {
            setQueryParams(prevState => deepmerge(prevState, { popId: event.target.value }));
        }
    };

    const onSelectReservationStatusesChange = () => {
        setQueryParams(prevState => ({ ...prevState, reservationStatuses }));
    };

    return (
        <Card variant="outlined" sx={ { mb: 4, width: '100%', backgroundColor: 'slate.50' } }>
            <CardContent sx={ { p: 3, pb: '24px !important' } }>


                <Box sx={ { display: 'flex', alignItems: 'center', mb: 3, gap: 1 } }>
                    <FilterListIcon color="action" fontSize="small"/>
                    <Typography variant="overline" color="text.secondary"
                                sx={ { fontSize: '0.85rem', fontWeight: 600 } }>
                        Filtry zamówień (rezerwacji)
                    </Typography>
                </Box>

                <Grid container spacing={ 3 } alignItems="flex-start">
                    <Grid item xs={ 12 } md={ 6 }>
                        <SelectFieldMultiple
                            size="small"
                            fullWidth
                            label="Pokaż po statusie"
                            options={ getReservationStatusOptions }
                            required
                            value={ reservationStatuses }
                            onClose={ () => onSelectReservationStatusesChange(reservationStatuses) }
                            onChange={ event => setReservationStatuses(event.target.value) }
                            sx={ {
                                '& .MuiInputBase-root': { height: '40px' },

                                '& .MuiSelect-select': {
                                    paddingTop: '0 !important',
                                    paddingBottom: '0 !important',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                },

                                '& .MuiChip-root': {
                                    height: '24px',
                                    marginTop: 0,
                                    marginBottom: 0
                                }
                            } }
                        />
                    </Grid>
                    <Grid item xs={ 12 } md={ 6 }>
                        <SelectField
                            size="small"
                            fullWidth
                            label="Wybierz punkt odbioru"
                            value={ pop }
                            onChange={ onSelectPopChange }
                            options={ [
                                { value: 'none', label: 'Wszystkie punkty' },
                                ...(getAllPops?.data?.map(pop => ({
                                    value: pop?.id,
                                    label: `${ pop?.hubName } / ${ pop?.name }`
                                })) || [])
                            ] }
                            sx={ {
                                '& .MuiInputBase-root': { height: '40px' }
                            } }
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default Filters;